"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _excluded = ["children", "title"];
var ThreadItemActions = function ThreadItemActions(_ref) {
  var actions = _ref.actions;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-full items-center z-10"
  }, actions.map(function (_ref2, index) {
    var onClick = _ref2.onClick,
      icon = _ref2.icon,
      title = _ref2.title;
    return /*#__PURE__*/_react["default"].createElement(ActionItem, {
      key: index,
      onClick: onClick,
      title: title
    }, icon);
  }));
};
ThreadItemActions.defaultProps = {};
function ActionItem(_ref3) {
  var children = _ref3.children,
    title = _ref3.title,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: title
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "p-2 rounded-full text-light hover:text-medium"
  }, rest), children));
}
var _default = exports["default"] = ThreadItemActions;
//# sourceMappingURL=Actions.js.map